var PaymentServiceProvider = /* @__PURE__ */ ((PaymentServiceProvider2) => {
  PaymentServiceProvider2["ADYEN"] = "ADYEN";
  PaymentServiceProvider2["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
  PaymentServiceProvider2["FAKE"] = "FAKE";
  PaymentServiceProvider2["PAYPAL"] = "PAYPAL";
  PaymentServiceProvider2["MFGROUP"] = "MFGROUP";
  return PaymentServiceProvider2;
})(PaymentServiceProvider || {});
var ExpressPaymentMethod = /* @__PURE__ */ ((ExpressPaymentMethod2) => {
  ExpressPaymentMethod2["APPLE_PAY"] = "APPLE_PAY";
  ExpressPaymentMethod2["GOOGLE_PAY"] = "GOOGLE_PAY";
  ExpressPaymentMethod2["AMAZON_PAY"] = "AMAZON_PAY";
  ExpressPaymentMethod2["PAYPAL"] = "PAYPAL";
  return ExpressPaymentMethod2;
})(ExpressPaymentMethod || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod2["BANCONTACT_CARD"] = "BANCONTACT_CARD";
  PaymentMethod2["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
  PaymentMethod2["BIZUM"] = "BIZUM";
  PaymentMethod2["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
  PaymentMethod2["CREDITCARD"] = "CREDITCARD";
  PaymentMethod2["FAKE"] = "FAKE";
  PaymentMethod2["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethod2["IDEAL"] = "IDEAL";
  PaymentMethod2["INVOICE"] = "INVOICE";
  PaymentMethod2["KLARNA"] = "KLARNA";
  PaymentMethod2["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
  PaymentMethod2["KLARNA_PAY_NOW"] = "KLARNA_PAY_NOW";
  PaymentMethod2["MBWAY"] = "MBWAY";
  PaymentMethod2["MOBILE_PAY"] = "MOBILE_PAY";
  PaymentMethod2["MULTIBANCO"] = "MULTIBANCO";
  PaymentMethod2["ONEY"] = "ONEY";
  PaymentMethod2["PAYPAL"] = "PAYPAL";
  PaymentMethod2["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
  PaymentMethod2["SWISH"] = "SWISH";
  PaymentMethod2["TWINT"] = "TWINT";
  return PaymentMethod2;
})(PaymentMethod || {});
var AdyenBrands = /* @__PURE__ */ ((AdyenBrands2) => {
  AdyenBrands2["VISA"] = "visa";
  AdyenBrands2["MASTERCARD"] = "mc";
  AdyenBrands2["AMEX"] = "amex";
  AdyenBrands2["BANCONTACTMC"] = "bcmc";
  AdyenBrands2["MAESTRO"] = "maestro";
  AdyenBrands2["DANKORT"] = "dankort";
  return AdyenBrands2;
})(AdyenBrands || {});
export {
  AdyenBrands,
  ExpressPaymentMethod,
  PaymentMethod,
  PaymentServiceProvider
};
//# sourceMappingURL=cart-payment-methods.js.map
